import React from 'react'
import Nav from '../Nav/index'
import Footer from '../Footer/index'
import Hero from './Hero/index'
import Content from './Content/index'

import { Helmet } from 'react-helmet'
import 'bootstrap/dist/css/bootstrap.css'
import './css/style.css'


function index() {

  return (
    <>

      <Helmet>
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11084448289"></script>

        <title>Heatwave Alert!! 5 Expert Tips to Beat the Heat | Kyno Health</title>
        <meta name="description" content="Stay cool and safe this summer with Kyno Health's expert tips to beat the heat during a heatwave. Learn essential strategies to protect yourself and your loved ones from extreme temperatures." data-react-helmet="true" />

        <meta name="keywords" content="" data-react-helmet="true"/>

        <link rel="canonical" href="https://www.kynohealth.com/blog/heatwave-alert-5-tips-to-beat-the-heat"/>
                     </Helmet>

      <Nav />
      <Hero />
      <Content />
      <Footer />
    </>
  )
}





export default index